import { render, staticRenderFns } from "./SettingsSecurityCourseWrapper.vue?vue&type=template&id=97e6f7b2&scoped=true"
import script from "./SettingsSecurityCourseWrapper.vue?vue&type=script&lang=js"
export * from "./SettingsSecurityCourseWrapper.vue?vue&type=script&lang=js"
import style0 from "./SettingsSecurityCourseWrapper.vue?vue&type=style&index=0&id=97e6f7b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e6f7b2",
  null
  
)

export default component.exports